exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n\n#gladlyChat_container .ChatIcon__chatIcon___eG4an {\n  cursor: pointer !important;\n  height: 24px !important;\n  width: 24px !important;\n}\n\n#gladlyChat_container .ChatIcon__chatIcon_wrapper___dxXSs:focus {\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n}\n\n#gladlyChat_container .ChatIcon__chatIcon_innerBubble___1BQNu {\n  fill: brandTertiary !important;\n}\n\n#gladlyChat_container .ChatIcon__chatIcon_innerBubble_lines___1lGKI {\n  stroke: brandPrimary !important;\n}", ""]);

// exports
exports.locals = {
	"chatIcon": "ChatIcon__chatIcon___eG4an",
	"chatIcon_wrapper": "ChatIcon__chatIcon_wrapper___dxXSs",
	"chatIcon_innerBubble": "ChatIcon__chatIcon_innerBubble___1BQNu",
	"chatIcon_innerBubble_lines": "ChatIcon__chatIcon_innerBubble_lines___1lGKI"
};